// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-popper[x-placement^=\"bottom\"] .popper__arrow::after {\n  top: 1px;\n  margin-left: -6px;\n  border-top-width: 0;\n  border-bottom-color: #4a4b5b;\n}\n.el-popper[x-placement^=\"bottom\"] .popper__arrow {\n  border-bottom-color: #4a4b5b;\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
